export function whenResize(callbackFunction) {
    window.addEventListener("resize", function(){
        callbackFunction();
    });
}